<template>
	<div>
			<p class="common-title mb-0">Add Product</p>
			<div class="block_1 block_2" >
		      <div class="mb-3 row">
		        
		        <div class="col-sm-10">
		          <input
		            type="number"
		            class="form-control"
		            v-model="good.item_no"
														placeholder="Item Number"
		          />
												<label class="">Item Number</label>
		        </div>
		      </div>
		      <div class="mb-3 row">
		        <div class="col-sm-6 pr-0">
											<v-select-popup type="tnved" v-model="good.hs_code" placeholder="HS Code"/>
		        </div>
		        <div class="col-sm-3">
		          <button class="btn btn-warning" style="height: 56px;" @click.prevent="showAISearchModal">
		            <i class="el-icon-view"></i>AI HS Code Search
		          </button>
		        </div>
		      </div>
		      <div class="mb-3 row">
		        
		        <div class="col-sm-10">
		          <input
		            type="text"
		            class="form-control"
		            v-model="good.good_name"
														placeholder="Commercial Description of Goods"
		          />
												<label class=""
		          >Commercial Description of Goods</label
		        >
		        </div>
		      </div>
		      <div class="mb-3 row">
		        
		        <div class="col-sm-10">
											<div class="select-wrapper">
		          <select
		            class="form-control"
		            v-model="good.state_of_good"
														placeholder="State of Goods"
														onchange=" this.dataset.chosen = this.value; " :data-chosen="good.state_of_good"
		          >
												<option value="" disabled selected>State of Goods</option>
												<option value="1">Yes</option>
												<option value="0">No</option>
												</select>
												<label class="">State of Goods</label>
											</div>
		        </div>
		      </div>
		      <div class="mb-3 row">
		        <div class="col-sm-10">
		          <NewSelectWrapper v-model="good.good_country" type="country" placeholder="Country of Origin"/>
		        </div>
		      </div>
		      <div class="mb-3 row">
		        
		        <div class="col-sm-10">
		          <input
		            type="text"
		            class="form-control"
		            v-model="good.sectoral_purpose"
														placeholder="Sectoral Purpose"
		          />
												<label class="">Sectoral Purpose</label>
		        </div>
		      </div>
		      <div class="mb-3 row">
		        
		        <div class="col-sm-10">
		          <input
		            type="number"
		            class="form-control"
		            v-model="good.packages_qty"
														placeholder="Packages"
		          />
												<label class="">Packages</label>
		        </div>
		      </div>
		      <div class="mb-3 row">
		        
		        <div class="col-sm-10">
		          <input
		            type="number"
														step="0.001"
		            class="form-control"
		            v-model="good.net_weight"
														placeholder="Net Weight (kg)"
		          />
												<label class="">Net Weight (kg)</label>
		        </div>
		      </div>
		      <div class="mb-3 row">
		        
										<div class="col-sm-4">
		          <input
												style="width: 100% !important"
													type="number"
													step="0.001"
													class="form-control"
													placeholder="Quantity"
		           v-model="good.measure_qty"
		          />
												<label class=""
		          >Quantity</label
		        >
		        </div>
		        <div class="col-sm-5">
		          <NewSelectWrapper
													type="measure"
													placeholder="Unit Of Measurement"
		           v-model="good.measure_code"
		          />
		        </div>
		      </div>
		      <div class="mb-3 row">
		        
		        <div class="col-sm-10">
		          <input
		            type="number"
		            class="form-control"
														step="0.01"
														placeholder="Unit Price"
		            v-model="good.unit_price"
		          />
												<label class="">Unit Price</label>
		        </div>
		      </div>
		      <div class="mb-3 row">
		        
		        <div class="col-sm-10">
		          <input
		            type="number"
														step="0.01"
		            class="form-control"
		            v-model="good.fob_value"
														placeholder="FOB Value"
		          />
												<label class="">FOB Value</label>
		        </div>
		      </div>
		      <div class="mb-3 row">
		        <div class="col-sm-10">
		          <input
												type="number"
														step="0.01"
		            class="form-control"
		            v-model="good.freight_charges"
														placeholder="Freight Charges"
		          />
												<label class=""
		          >Freight Charges</label
		        >
		        </div>
		      </div>
		      <div class="mb-3 row">
		        <div class="col-sm-10"> <input
											type="number"
														step="0.01"
		            class="form-control"
		            v-model="good.free_of_charge"
														placeholder="Free of Charge"
		          />	
												<label class="">Free of Charge</label>
		        </div>
		      </div>
		    </div>
						<div class="d-flex justify-content-between mt-3">
							<button class="btn btn-outline-secondary" @click.prevent="cancel">Cancel</button>
							<button class="btn btn-success" @click.prevent="save">Save</button>
						</div>
						<b-modal id="ai-search-modal" :hide-footer=true size="lg" :title="($t('message.contracts.ai_search'))">
							<div class="form-group d-flex flex-column">
								<textarea class="form-control" id="ai-search-modal-text-area" rows="3" v-model="ai_search.ai_search_input"></textarea>
								<div class="row mt-2 justify-content-end">
									<button @click="AISearchCancel()" class="btn btn-lg btn-outline-danger p-0 d-flex justify-content-center align-items-center" style="height: 40px; font-size: 14px; width: 150px;">
										{{$t('message.cancel')}}
									</button>
									<button :disabled="ai_search.ai_search_button_disabled" class="btn btn-lg btn-outline-success p-0 ml-2 mr-3 d-flex justify-content-center align-items-center" @click="AISearch()" style="height: 40px; font-size: 14px; width: 150px;">
										<svg v-if="ai_search.ai_search_button_disabled" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16 " style="width: 20px; height: 20px; animation: loader-rotate 1s linear infinite" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>
										<div v-else class="row px-0 mx-0 text-nowrap">
											{{$t('message.contracts.run')}}
										</div>
									</button>
								</div>
							</div>
							<div>
								{{ ai_search.ai_search_results }}
							</div>
						</b-modal>
					</div>
</template>
<script>
	import NewSelectWrapper from './../../fields/NewSelectWrapper.vue';
	export default {
		name: "FormMEditProductForm",
		props: {indata: {type: Object}, index: {type: Number}},
		components: {
    NewSelectWrapper,
		},
		mounted(){
			this.good = {...this.indata}
		},
		methods: {
			AISearch(){
				if (this.ai_search.ai_search_input.length < 3) return
				this.ai_search.ai_search_button_disabled = true
				axios.get(window.base+'/library/bardapi?query='+encodeURIComponent(this.ai_search.ai_search_input)).then(response=>{
					if (this.ai_search.ai_search_button_disabled === false){
						return
					}
					this.ai_search.ai_search_results = response.data
				}).finally(()=>{
					this.ai_search.ai_search_button_disabled = false
				})
			},
			AISearchCancel(){
				this.ai_search.ai_search_button_disabled = false
				this.ai_search.ai_search_input = ""
				this.ai_search.ai_search_results = ""
			},
			showAISearchModal(){
				if(this.good.good_name)
					this.ai_search.ai_search_input = `What is HS code for ${this.good.good_name}?`;
				this.$bvModal.show('ai-search-modal');
			},
			/**
				* Triggers adding of a productto the array of products
				*/
			save(){
				this.$emit('save', {good: this.good, index: this.index})
			},
			/**
				* Cancels adding products.
				*/
			cancel(){
				this.$emit('cancel')
			}
		},
		data(){
			return {
				ai_search: {
					ai_search_input: '',
					ai_search_results: '',
					ai_search_button_disabled: false,
				},
				good: {
					sgd_id: 0,
					sgd_good_guid: '', //40
					sgd_guid: '', //40
					item_no: 0,
					hs_code: '', //12
					good_name: '', //256
					state_of_good: 0,
					good_country: '', //2
					sectoral_purpose: '', //20
					packages_qty: 0,
					packages_code: 0,
					net_weight: 0,
					measure_code: '', //3
					measure_qty: 0,
					unit_price: 0,
					fob_value: 0,
					freight_charges: 0,
					free_of_charge: 0,
					user_id: 0,
					sgd_item_date: '',
				}
			}
		}
	}
</script>